import React from 'react';
import sIcon1 from '../../images/icons/icon_clock.svg'
import sIcon2 from '../../images/icons/icon_dart_board_2.svg'
import sIcon3 from '../../images/icons/icon_target.svg'

const Policy = [
    {
        title: 'Our History',
        subTitle: 'Established in 2016 in Sardarshahar, India, AnuWebSolutions has grown into a trusted web development company, delivering innovative and results-driven solutions worldwide.',
        icon: sIcon1,
    },
    {
        title: 'Our Mission',
        subTitle: 'To provide high-quality, cost-effective, and user-friendly web solutions that help businesses succeed online, leveraging the latest technologies and best practices.',
        icon: sIcon2,
    },
    {
        title: 'Our Vision',
        subTitle: 'To be a global leader in web development and digital marketing, driving innovation and excellence while building long-term client relationships.',
        icon: sIcon3,
    },


]


const PolicySection = (props) => {

    return (
        <section className="policy_section bg-light">
            <div className="container">
                <div className="row">
                    {Policy.map((policy, pitem) => (
                        <div className="col-lg-4" key={pitem}>
                            <div className="iconbox_block">
                                <div className="iconbox_icon">
                                    <img src={policy.icon} alt="Dollar SVG Icon" />
                                </div>
                                <div className="iconbox_content">
                                    <h2 className="iconbox_title">{policy.title}</h2>
                                    <p className="mb-0">
                                        {policy.subTitle}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PolicySection;